import { DetailedHTMLProps, FC, HTMLAttributes, ReactNode } from 'react';

import classNames from 'classnames';

import './TableBody.scss';

import { TestMetadata } from '../types';

export interface Props
  extends DetailedHTMLProps<
    HTMLAttributes<HTMLTableSectionElement>,
    HTMLTableSectionElement
  > {
  /** Table content */
  children?: ReactNode;
  /** Table's classname  */
  className?: string;
  // Test IDs for component sections
  testMetadata?: TestMetadata;
}

const TableBody: FC<Props> = ({
  children,
  className,
  testMetadata,
  ...otherProps
}) => {
  return (
    <tbody
      {...otherProps}
      className={classNames('sb-table-body', className)}
      {...testMetadata}
    >
      {children}
    </tbody>
  );
};

export default TableBody;
